var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-map"},[_c('div',{staticClass:"d-flex"},_vm._l((_vm.paths),function(p,index){return _c('div',{key:index,staticClass:"item"},[_vm._v(_vm._s(p))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }